module.exports = __webpack_public_path__ + "img/install-type-standard-gutter.jpg";